// extracted by mini-css-extract-plugin
module.exports = {"MobilePadding":"_38_cl"};